import { PageContent } from '@/components';
import { JarFlyerboardList } from './JarFlyerboardList';
import { JarHeader } from './JarHeader';

export const Jar: React.FC = () => (
  <>
    <JarHeader />
    <PageContent >
      <JarFlyerboardList />
    </PageContent>
  </>
);
